<template>
    <button v-if="isValid" type="button" class="btn btn-primary" @click="validate">Valider</button>
</template>

<script>
    import store from '../../store';
    import {mapState, mapActions, mapGetters, mapMethods} from 'vuex';

    const OrderSubmit = {
        name: 'ponroy-order-submit',
        store,
        props: {
        },
        computed: {
            ...mapGetters('order', [
                'shippingAddress',
                'billingAddress',
                'isSameAddress',
                'shippingAddressErrors',
                'billingAddressErrors',
                'carrier',
                'colissimoPoint',
                'isLoadingAddresses',
                'isLoadingShippingAddress',
                'isLoadingColissimo',
                'hasForbiddenProduct',
            ]),
            isValid() {

                if (this.isLoadingShippingAddress || this.isLoadingAddresses || this.isLoadingColissimo || this.hasForbiddenProduct) {
                    return false;
                }

                if (this.shippingAddressErrors && 0 < Object.keys(this.shippingAddressErrors).length) {
                    return false;
                }

                if (this.billingAddressErrors && 0 < Object.keys(this.billingAddressErrors).length) {
                    return false;
                }

                if (null === this.shippingAddress) {
                    return false;
                }

                if (null === this.billingAddress) {
                    return false;
                }

                if (this.isSameAddress && (this.shippingAddress.id !== this.billingAddress.id)) {
                    return false;
                }

                if (!this.isSameAddress && (this.shippingAddress.id === this.billingAddress.id)) {
                    return false;
                }

                if (!this.carrier) {
                    return false;
                }

                if (0 === Object.keys(this.carrier).length) {
                    return false;
                }

                if (true === this.carrier.isRelay && null === this.colissimoPoint) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            validate(e) {
                this.$store.commit('order/SET_INVALID_ADDRESS', null);

                if (!RegExp('^[0-9]+$').test(this.shippingAddress.phone)) {
                    this.$store.commit('order/SET_INVALID_ADDRESS', this.shippingAddress);
                    return;
                }

                if (!RegExp('^[0-9]+$').test(this.billingAddress.phone)) {
                    this.$store.commit('order/SET_INVALID_ADDRESS', this.billingAddress);
                    return;
                }

                if (this.isValid) {
                    document.getElementById('checkoutForm').submit();
                }
            }
        },
        watch: {
        }
    };

    export default OrderSubmit;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/Order/OrderSubmit.vue